var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from 'react';
import t from 'prop-types';
import Entrada from './entrada';
import ContenedorUnidadesIndice from './contenedor-unidades-indice';

var TituloContenedor = function TituloContenedor(_ref) {
  var titulo = _ref.titulo;

  if (!titulo) {
    return null;
  }

  return React.createElement('div', {
    className: 'tituloContenedor',
    dangerouslySetInnerHTML: {
      __html: titulo
    }
  });
};

TituloContenedor.propTypes = process.env.NODE_ENV !== "production" ? {
  titulo: t.string
} : {};

var ContenedorIndice = function (_React$Component) {
  _inherits(ContenedorIndice, _React$Component);

  function ContenedorIndice() {
    _classCallCheck(this, ContenedorIndice);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }
  /**
   * pinta las lecciones de la unidad seleccionada
   * solo tiene sentido si hay un solo contenedor de unidades
   */


  ContenedorIndice.prototype.renderLecciones = function renderLecciones() {
    var _props = this.props,
        contenedoresUnidades = _props.contenedoresUnidades,
        indexUnidad = _props.indexUnidad,
        onEntrada = _props.onEntrada;
    var unidadSeleccionada = contenedoresUnidades[0].unidades[indexUnidad]; // si no existe la unidad seleccionada, o no tiene lecciones, no hay nada que renderizar

    if (!unidadSeleccionada || !unidadSeleccionada.lecciones) {
      return null;
    }

    var numUnidad = unidadSeleccionada.numUnidad,
        lecciones = unidadSeleccionada.lecciones;
    return React.createElement('div', {
      className: "contenedorLeccionesIndice leccionesUd" + numUnidad
    }, lecciones.map(function (leccion, index) {
      if (!leccion.clase) {
        leccion.clase = 'leccion';
      }

      return React.createElement(Entrada, _extends({
        key: 'unidad-index-' + index
      }, leccion, {
        onClick: function onClick() {
          return onEntrada(leccion, index);
        }
      }));
    }));
  };

  ContenedorIndice.prototype.renderExtras = function renderExtras() {
    var _props2 = this.props,
        extrasContenedor = _props2.extrasContenedor,
        onEntrada = _props2.onEntrada;
    return extrasContenedor.map(function (entrada, index) {
      return React.createElement(Entrada, _extends({
        key: 'entrada-extra-contenedor-index-' + index
      }, entrada, {
        onClick: function onClick() {
          return onEntrada(entrada, index);
        }
      }));
    });
  };

  ContenedorIndice.prototype.render = function render() {
    var _props3 = this.props,
        indexUnidad = _props3.indexUnidad,
        titulo = _props3.titulo,
        extrasContenedor = _props3.extrasContenedor,
        contenedoresUnidades = _props3.contenedoresUnidades,
        onEntrada = _props3.onEntrada;
    return React.createElement('div', {
      className: 'contenedorIndice'
    }, React.createElement(TituloContenedor, {
      titulo: titulo
    }), contenedoresUnidades.map(function (contenedorUnidades, index) {
      return React.createElement(ContenedorUnidadesIndice, _extends({
        key: 'contenedorUnidadesIndice-' + index
      }, contenedorUnidades, {
        indexUnidad: indexUnidad,
        onEntrada: onEntrada
      }));
    }), this.renderLecciones(), extrasContenedor && this.renderExtras());
  };

  return ContenedorIndice;
}(React.Component);

ContenedorIndice.propTypes = process.env.NODE_ENV !== "production" ? {
  libroId: t.string.isRequired,
  titulo: t.string,
  contenedoresUnidades: t.arrayOf(t.shape({
    titulo: t.string,
    unidades: t.arrayOf(t.object).isRequired
  })).isRequired,
  extrasContenedor: t.arrayOf(t.object),
  // configIndice: t.shape({
  //     tituloContenedor: t.string,
  //     unidades: t.array, // o tiene 'unidades' o tiene 'contenedorUnidades', pero no ambos a la vez
  //     contenedoresUnidades: t.shape({
  //         unidades
  //     })
  // }).isRequired,
  indexUnidad: t.number,
  // index de la unidad actualmente seleccionada
  // onIndice: t.func.isRequired,
  // onAtras: t.func.isRequired,
  onEntrada: t.func.isRequired
} : {};
export default ContenedorIndice;